/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import { GameDataHandler } from '../GameDataHandler';
import { LevelNameValues, LevelState, LevelStateValues } from '../level/levels/level';
/* END-USER-IMPORTS */

export default class LevelTile extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 105.5, y ?? 72.5);

    // box
    const box = scene.add.image(0, 1, "level-select", "level-box.png");
    this.add(box);

    // levelName
    const levelName = scene.add.text(0, 8, "", {});
    levelName.setOrigin(0.5, 0.5);
    levelName.visible = false;
    levelName.text = "1";
    levelName.setStyle({ "color": "#b29a5e", "fontFamily": "FREDFREDBURGER-BOLD ", "fontSize": "60px" });
    levelName.setPadding({"left":5,"right":5});
    this.add(levelName);

    // title
    const title = scene.add.text(0, -41, "", {});
    title.setOrigin(0.5, 0.5);
    title.text = "Level";
    title.setStyle({ "color": "#b29a5e", "fontFamily": "FREDFREDBURGER-BOLD ", "fontSize": "32px" });
    this.add(title);

    // note
    const note = scene.add.image(0, 0, "common", "note.png");
    note.visible = false;
    this.add(note);

    // price
    const price = scene.add.text(-4, 4, "", {});
    price.setOrigin(0.5, 0.5);
    price.visible = false;
    price.text = "500";
    price.setStyle({ "color": "#ffffffff", "fontFamily": "FREDFREDBURGER-BOLD ", "fontSize": "40px" });
    this.add(price);

    // padlock
    const padlock = scene.add.image(0, 0, "level-select", "padlock.png");
    padlock.visible = false;
    this.add(padlock);

    // highscoreContainer
    const highscoreContainer = scene.add.container(0, 43);
    this.add(highscoreContainer);

    // highscoreBack
    const highscoreBack = scene.add.image(0, 0, "level-select", "level-high.png");
    highscoreContainer.add(highscoreBack);

    // highScoreText
    const highScoreText = scene.add.text(-5, 3, "", {});
    highScoreText.setOrigin(0, 0.5);
    highScoreText.text = "145";
    highScoreText.setStyle({ "color": "#fbeecfff", "fontFamily": "FREDFREDBURGER-BOLD ", "fontSize": "30px" });
    highScoreText.setPadding({"left":5,"right":5});
    highscoreContainer.add(highScoreText);

    // highScoreTrophy
    const highScoreTrophy = scene.add.image(-47, 0, "level-select", "trophy.png");
    highScoreTrophy.scaleX = 0.3;
    highScoreTrophy.scaleY = 0.3;
    highscoreContainer.add(highScoreTrophy);

    // level_playbtn
    const level_playbtn = scene.add.image(-1, 24, "level-select", "level-play.png");
    this.add(level_playbtn);

    // level_replaybtn
    const level_replaybtn = scene.add.image(-2, 2, "level-select", "level-replay.png");
    this.add(level_replaybtn);

    // title (components)
    const titleFitTextToBounds = new FitTextToBounds(title);
    titleFitTextToBounds.maxWidth = 180;
    titleFitTextToBounds.minFontSize = 8;
    titleFitTextToBounds.constrainByWidth = true;
    const titleLocaliseText = new LocaliseText(title);
    titleLocaliseText.copyId = "level";

    this.box = box;
    this.levelName = levelName;
    this.title = title;
    this.note = note;
    this.price = price;
    this.padlock = padlock;
    this.highscoreContainer = highscoreContainer;
    this.highscoreBack = highscoreBack;
    this.highScoreText = highScoreText;
    this.highScoreTrophy = highScoreTrophy;
    this.level_playbtn = level_playbtn;
    this.level_replaybtn = level_replaybtn;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    this.levelName.text = this.name;
    /* END-USER-CTR-CODE */

    // custom definition props
    this.linkedLevel = "level1";
    this.state = "Locked";
  }

  private box: Phaser.GameObjects.Image;
  private levelName: Phaser.GameObjects.Text;
  private title: Phaser.GameObjects.Text;
  private note: Phaser.GameObjects.Image;
  private price: Phaser.GameObjects.Text;
  private padlock: Phaser.GameObjects.Image;
  private highscoreContainer: Phaser.GameObjects.Container;
  private highscoreBack: Phaser.GameObjects.Image;
  private highScoreText: Phaser.GameObjects.Text;
  private highScoreTrophy: Phaser.GameObjects.Image;
  private level_playbtn: Phaser.GameObjects.Image;
  private level_replaybtn: Phaser.GameObjects.Image;
  public name: string = "";
  public nextLevel!: LevelTile | undefined;
  public unlockCost: number = 50;
  public soundOnPurchasedSelected: string = "SndItemClick";
  public soundOnPurchaseSuccess: string = "SndLevelUnlock";
  public soundOnPurchaseFailure: string = "SndLevelLocked";
  public soundOnLockedSelected: string = "SndLevelLocked";
  public largeFontSize: number = 72;
  public normalFontSize: number = 60;
  public largePositionY: number = 22;
  public normalPositionY: number = 8;

  /* START-USER-CODE */
  public static events = {
    LevelSelected: 'levelSelected',
    LevelPurchased: 'levelPurchased'
  } as const;

  public state: LevelStateValues;
  public linkedLevel: LevelNameValues;
  protected initScaleX!: number;
  protected initScaleY!: number;
  protected highScore!: number;
  protected pointsToSpend!: number;

  public awake() {
    //this.levelName.text = this.name;
    let title = app.localeHandler.getLocalisedTextById('level');
    this.title.text = app.localeHandler.isRTL() ? `${this.name} ${title}` : `${title} ${this.name}`;
    this.price.text = this.unlockCost.toString();
    this.highScore = GameDataHandler.getHighScore(this.scene, this.linkedLevel);
    this.highScoreText.text = this.highScore.toString();
    this.pointsToSpend = this.scene.game.registry.get(GameDataHandler.keys.EarnedPoints);

    this.bindInput();

    this.scene.game.registry.events.on(GameDataHandler.events.ChangeEarnedPoints, this.onPointsChange, this);
    this.on(
      Phaser.GameObjects.Events.DESTROY,
      () => {
        this.scene.game.registry.events.off(GameDataHandler.events.ChangeEarnedPoints, this.onPointsChange, this);
      },
      this
    );

    this.refreshState();
  }

  public changeState(state: LevelStateValues) {
    this.state = state;
    this.refreshState();
  }

  public refreshState() {
    this.scene.tweens.killTweensOf([this.note, this.price]);
    this.note.scaleX = this.note.scaleY = 1;
    this.price.scaleX = this.price.scaleY = 1;

    /*if (this.state == LevelState.Purchased) {
      this.padlock.setVisible(false);
      this.price.setVisible(false);
      this.note.setVisible(false);
      this.title.setVisible(true);
      //this.levelName.setVisible(true);
      this.highscoreBack.setVisible(this.highScore > 0);
      this.highScoreTrophy.setVisible(this.highScore > 0);
      this.highScoreText.setVisible(this.highScore > 0);

      if (this.highScore > 0) {
        this.levelName.setFontSize(this.normalFontSize);
        this.levelName.y = this.normalPositionY;
        this.level_playbtn.setVisible(false);
        this.level_replaybtn.setVisible(true);
      } else {
        this.levelName.setFontSize(this.largeFontSize);
        this.levelName.y = this.largePositionY;
        this.level_playbtn.setVisible(true);
        this.level_replaybtn.setVisible(false);
      }
    } else */
    if (this.state == LevelState.Unlocked) {
      this.padlock.setVisible(false);
      this.price.setVisible(false);
      this.note.setVisible(false);
      this.title.setVisible(true);
      //this.levelName.setVisible(true);
      this.highscoreBack.setVisible(this.highScore > 0);
      this.highScoreTrophy.setVisible(this.highScore > 0);
      this.highScoreText.setVisible(this.highScore > 0);

      if (this.highScore > 0) {
        this.levelName.setFontSize(this.normalFontSize);
        this.levelName.y = this.normalPositionY;
        this.level_playbtn.setVisible(false);
        this.level_replaybtn.setVisible(true);
      } else {
        this.levelName.setFontSize(this.largeFontSize);
        this.levelName.y = this.largePositionY;
        this.level_playbtn.setVisible(true);
        this.level_replaybtn.setVisible(false);
      }
    } else {
      this.padlock.setVisible(true);
      this.price.setVisible(false);
      this.note.setVisible(false);
      this.title.setVisible(false);
      //this.levelName.setVisible(false);
      this.highScoreTrophy.setVisible(false);
      this.highScoreText.setVisible(false);
      this.highscoreBack.setVisible(false);
      this.level_playbtn.setVisible(false);
      this.level_replaybtn.setVisible(false);
    }
  }

  public unlock(previousLevel?: LevelTile) {
    GameDataHandler.unlockLevel(this.scene, this.linkedLevel);
    this.onUnlocked();
  }

  protected bindInput() {
    this.initScaleX = this.scaleX;
    this.initScaleY = this.scaleY;

    this.setSize(this.box.displayWidth, this.box.displayHeight);
    this.setInteractive();

    this.on(Phaser.Input.Events.POINTER_DOWN, () => {
      this.scene.add.tween({
        targets: [this.level_playbtn,this.level_replaybtn],
        scaleX: 0.8,
        scaleY: 0.8,
        duration: 80
        // yoyo: true,
      });

      this.scene.add.tween({
        targets: [this.padlock],
        angle:10,
        duration: 80,
        loop: 4,
        yoyo: true,
      });
      if(this.state == LevelState.Locked){
        //app.audioHandler.playSound(this.scene, 'SndLevelLocked', 'sfx');
        app.audioHandler.playSound(this.scene, this.soundOnLockedSelected, 'sfx');
      }
    });

    this.on(Phaser.Input.Events.POINTER_UP, () => {
      this.scene.add.tween({
        targets: [this.level_playbtn,this.level_replaybtn],
        scaleX: 1,
        scaleY: 1,
        duration: 80,
        ease: Phaser.Math.Easing.Cubic.InOut,
        // yoyo: true,
        onComplete: () => {
          this.onPressed();
        }
      });
    });

    this.on(Phaser.Input.Events.POINTER_OUT, () => {
      this.scene.add.tween({
        targets: [this.level_playbtn,this.level_replaybtn],
        scaleX: 1,
        scaleY: 1,
        duration: 80,
        ease: Phaser.Math.Easing.Cubic.InOut
        // yoyo: true,
        // onComplete: () => {}
      });
    });
  }

  protected onPressed() {
    // if (this.state == LevelState.Purchased) {
    //   this.onSelected();
    // } else
    if (this.state == LevelState.Unlocked) {
      // if (GameDataHandler.canPurchase(this.scene, this.unlockCost)) this.onPurchaseSuccess();
    this.onSelected();
    } else {
      this.onLocked();
    }
  }

  protected onSelected() {
    app.audioHandler.playSound(this.scene, this.soundOnPurchasedSelected, 'sfx');
    this.emit(LevelTile.events.LevelSelected, this);
  }

  protected onPurchaseSuccess() {
    //GameDataHandler.spendEarnedPoints(this.scene, this.unlockCost);
    GameDataHandler.purchaseLevel(this.scene, this.linkedLevel);

    app.audioHandler.playSound(this.scene, this.soundOnPurchaseSuccess, 'sfx');

    this.emit(LevelTile.events.LevelPurchased, this);

    this.title.alpha = 0;
    //this.levelName.alpha = 0;
    this.level_playbtn.alpha = 0;
    this.title.setVisible(true);
    //this.levelName.setVisible(true);
    this.level_playbtn.setVisible(true);

    this.scene.add.tween({
      targets: [this.note, this.price],
      alpha: 0,
      scale: 1.6,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut,
      onComplete: () => {
        this.note.setVisible(false);
        this.price.setVisible(false);
      }
    });

    this.scene.add.tween({
      targets: [this.title, this.level_playbtn],
      alpha: 1,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: 100
    });

    this.state = LevelState.Purchased;

    if (this.nextLevel) {
      this.scene.time.delayedCall(500, this.nextLevel.unlock, [this], this.nextLevel);
    }
  }

  protected onPurchaseFail() {
    app.audioHandler.playSound(this.scene, this.soundOnPurchaseFailure, 'sfx');
  }

  protected onUnlocked() {
    this.note.alpha = 0;
    this.price.alpha = 0;
    this.note.setVisible(true);
    this.price.setVisible(true);

    this.scene.add.tween({
      targets: this.padlock,
      alpha: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.InOut,
      onComplete: () => {
        this.padlock.setVisible(false);
      }
    });

    this.scene.add.tween({
      targets: [this.note, this.price],
      alpha: 1,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut,
      delay: 400
    });

    this.state = LevelState.Unlocked;
  }

  protected onLocked() {
    //app.audioHandler.playSound(this.scene, this.soundOnLockedSelected, 'sfx');
  }

  protected onPointsChange(parent: any, value: any, previousValue: any) {
    this.pointsToSpend = value;
    this.refreshState();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
